import { BaseDocument } from '../BaseDocument';
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { IListForm } from '../../interfaces/ilist-form';
import { CrudOperations } from '../../interfaces/crudOperations';
import { State } from '../models/State';
import { MatTableDataSource, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { BasePagedDataSource } from '../table/paged-table-base.datasource';
import { IPageInfo } from '../interfaces/IPageInfo';

export class PagedListForm<T extends BaseDocument> implements OnInit, IListForm<T>{
    /**
     *
     */
    routeRoot:string;
    protected dataService:CrudOperations<T>;
    protected router: Router;
    public states?:State[];
    public sortString?:string;
    private pageIndex = 0;
    private queryString:string;
    public sortDesc:boolean = false;
    public dataSource:BasePagedDataSource<T> = null;
    constructor(dataService:CrudOperations<T>,routeRoot:string,router: Router,states?:State[], sort?:string, sortDesc:boolean =false) {
        this.dataService = dataService;
        this.routeRoot = routeRoot;        
        this.router = router;
        this.states = states;
        this.sortString = sort;
        this.sortDesc = sortDesc;
        this.dataSource = new BasePagedDataSource<T>(dataService,null,this.sortString,null,sortDesc);
    }
    onLoad() {
        this.dataSource.loadData();
    }
    public onAdd() {
        this.router.navigate([`${this.routeRoot}/add`]);
    }
    public onEdit(item:T) {
        if(item && item.id){
            this.router.navigate([`${this.routeRoot}/edit`,item.id]);
        }
    }
    onRefresh() {
        this.onLoad();        
    }
    ngOnInit() {
        this.onLoad();
    }
    onFilter(filter:string, pageIndex: number = 0){
        this.queryString = filter;
        this.pageIndex = pageIndex;
        this.dataSource = new BasePagedDataSource<T>(this.dataService,filter,this.sortString,null,this.sortDesc);
        this.dataSource.loadData(<PageEvent> {
            pageIndex:this.pageIndex
        });
    }
    public get PageInfo():IPageInfo {        
        return this.dataSource?this.dataSource.pageInfo:null;
    }
    public onPrevPage() {
        if(this.pageIndex > 0){
            this.onFilter(this.queryString, this.pageIndex - 1);
        }        
    }
    public onNextPage() {
        this.dataSource.pageInfo
        this.onFilter(this.queryString, this.pageIndex + 1);
    }
}